<h2 mat-dialog-title>{{ 'New Offer' | translate }}</h2>
<mat-dialog-content>
  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Name' | translate }}</div>
    <input matInput type="text" [(ngModel)]="name">
  </div>
  <div class="cdc-form-field actif" [ngClass]="{'error': (updated && codes.length <= 0) || codeExists}">
    <div class="cdc-label">{{ "Codes" | translate }}</div>
    <mat-form-field class="select-container select-chips w-100">
      <mat-chip-grid #codesList>

        <mat-chip *ngFor="let code of codes" (removed)="onRemoveCode(code)">
          {{ code }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>

        <input [matChipInputFor]="codesList" class="chip-input-multiple" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="onAddCode($event)" (input)="onInputChange($event)" autocomplete="off" />
      </mat-chip-grid>
    </mat-form-field>

    <mat-error [ngClass]="{'hidden':!(updated && codes.length <= 0)}">{{ 'Cannot be empty.' | translate }}</mat-error>
    <mat-error [ngClass]="{'hidden':!codeExists}">{{ 'The code already exists.' | translate }}</mat-error>
  </div>
  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Expiration delay' | translate }} ({{ "hours" | translate }})</div>
    <input matInput type="number" min="0" [(ngModel)]="expirationDelay"
      (focusout)="expirationDelay = ((expirationDelay != null && expirationDelay != undefined && expirationDelay < 0) ? 0 : expirationDelay)">
  </div>
  <div class="cdc-form-field actif">
    <mat-checkbox [(ngModel)]="isRequired">
      {{ 'Required' | translate }}
    </mat-checkbox>
  </div>
  <div class="cdc-form-field actif">
    <mat-checkbox [(ngModel)]="hidden">
      {{ 'Single route' | translate }}
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()" [disabled]="codes.length <= 0 || !updated">{{
    'Confirm' | translate }}</button>
</mat-dialog-actions>
